import React from 'react';
import { translate } from 'translations/i18n';
import { Button } from '@companycam/slab-web';

import Header from './Header';
import Footer from './Footer';

type ViewWrapperProps = {
  children: React.ReactNode;
  footerVisible?: boolean;
  handleConfirmClick?: () => void;
  isConfirmDisabled?: boolean;
  handleCancelClick?: () => void;
  isCancelDisabled?: boolean;
  onConfirm: () => void;
  headerTitle: string;
  headerDescription: string;
};

const NOOP = () => {};

const ViewWrapper = ({
  children,
  onConfirm,
  footerVisible = true,
  handleConfirmClick = NOOP,
  isConfirmDisabled = true,
  handleCancelClick = NOOP,
  isCancelDisabled = true,
  headerTitle,
  headerDescription,
}: ViewWrapperProps) => {
  return (
    <>
      <Header
        title={headerTitle}
        description={headerDescription}
        hideModal={onConfirm}
      />
      {children}
      {footerVisible ? (
        <Footer>
          <Button
            color="primary"
            onClick={handleConfirmClick}
            disabled={isConfirmDisabled}
          >
            {translate('common.confirm')}
          </Button>
          <Button onClick={handleCancelClick} disabled={isCancelDisabled}>
            {translate('common.cancel')}
          </Button>
        </Footer>
      ) : null}
    </>
  );
};

export default ViewWrapper;
